<template>
  <div class="pageContent">
    <div class="pageTitleBox">
      <img src="../../assets/images/equipmentData2.png" alt="logo" class="pageTitleIcon">设备详情
      <span @click="$router.push({name:'InstrumentList'})" class="back">返回</span>
    </div>
    <div class="infoBox">
      <div class="left">
        <img :src="'/prod-api'+data.pictureUrl" alt="仪器" class="yiqiImg">
        <div class="cfdd">
          <img src="../../assets/images/site.png" alt="地点" class="cfddImg">放置地点：<div class="cunfddText">{{ data.storagePlace }}</div>
        </div>
      </div>
      <div class="right">
        <div class="titleBox">
          <div class="chineseTitle">{{ data.assetName }}</div>
          <div class="statusBox">在用</div>
        </div>
        <div class="englishTitle">{{ data.ename }}</div>
        <div class="infos">
          <div class="infoItem">资产编号：<span class="data">{{ data.assetCode }}</span></div>
          <div class="infoItem">规格/型号：<span class="data">{{ data.modelCode }}</span></div>
          <div class="infoItem">生产产商：<span class="data">{{ data.manufacturer }}</span></div>
          <div class="infoItem">设备单价：<span class="data">{{ data.cost }} 万元</span></div>
          <div class="infoItem">所属单位：<span class="data">{{ data.deptName }}</span></div>
          <div class="infoItem">学习资料：
            <span class="data"><a v-if="data.learningMaterials" :href="data.learningMaterials" download>下载</a><span v-else>无</span></span>
          </div>
          <div class="fzrItem">
            <div class="fzr">负责人：</div>
            <div class="fzrData">
              <div class="data">{{ data.contacts }} 电话：{{ data.contactNumber }}    邮箱：{{ data.mailbox ? data.mailbox : '无' }}</div>
            </div>
          </div>
          <div class="infoItem"><a href="javascript:;" @click="reserve" class="reserveBtn">预约</a></div>
        </div>
      </div>
    </div>
    <div class="tabs">
      <div :class="{'tabBtn': true, 'active': active === 0}" @click="$router.push({ name: 'DayiDetail', query: $route.query })">仪器详细信息</div>
      <div :class="{'tabBtn': true, 'active': active === 1}" @click="$router.push({ name: 'DayiReserve', query: $route.query })">仪器预约</div>
      <!-- <div :class="{'tabBtn': true, 'active': active === 2}" @click="$router.push({ name: 'DayiOption', query: $route.query })">自主操作培训</div>
      <div :class="{'tabBtn': true, 'active': active === 3}" @click="$router.push({ name: 'DayiConsult', query: $route.query })">咨询建议</div>
      <div :class="{'tabBtn': true, 'active': active === 4}" @click="$router.push({ name: 'DayiHistory', query: $route.query })">预约记录</div>
      <div :class="{'tabBtn': true, 'active': active === 5}" @click="$router.push({ name: 'DayiOtRecord', query: $route.query })">操作记录</div> -->
    </div>
    <div class="tabMain">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import notification from 'ant-design-vue/es/notification'
import { http } from '@/utils/http'

export default {
  name: 'InstrumentDetail',
  data() {
    return {
      active: 0,
      data: {}
    }
  },
  watch: {
    $route: {
      handler(val) {
        this.getActive()
        this.getDetail()
      },
      immediate: true
    }
  },
  methods: {
    getActive() {
      let title = this.$route.meta.title
      switch(title) {
        case '仪器详细信息':
          this.active = 0
          break
        case '仪器预约':
          this.active = 1
          break
        case '自主操作培训':
          this.active = 2
          break
        case '咨询建议':
          this.active = 3
          break
        case '历史记录':
          this.active = 4
          break
        case '操作记录':
          this.active = 5
          break
      }
    },
    getDetail() {
      if (!this.$route.query.code) return
      let parameter = {
        assetCode: this.$route.query.code,
        pageNum: 1,
        pageSize: 1,
      }
      http('/reservation/openTheInstrument', 'POST', parameter).then(res => {
        if (res.success) {
          this.data = res.data.resultList[0]
        }
      })
    },
    reserve() {
      // if (!localStorage['TKYMHAUTH']) {
      //   notification.warning({
      //     message: '未登录',
      //     description: '请先登录再进行预约'
      //   })
      //   this.$router.push({ name: 'login' })
      // } else {
      //   http('/user/info', 'GET', {}, localStorage['TKYMHAUTH']).then(res => {
      //     if(res.success){
      //       window.open(`${process.env.VUE_APP_URL}/home/taskSheetManagement/appointment?auth=${localStorage['TKYMHAUTH']}&id=${this.data.id}`)
      //       console.log(process.env.VUE_APP_URL)
      //     } else {
      //       notification.warning({
      //         message: '登录过期',
      //         description: '请先登录再进行预约'
      //       })
      //       this.$router.push({ name: 'login' })
      //     }
      //   })
      // }
      window.open(`${process.env.VUE_APP_URL}`)
    }
  }
}
</script>

<style lang="less" scoped>
.pageContent {
  padding-bottom: 24px;
  width: 100%;
}
.infoBox {
  margin-top: 22px;
  display: flex;
  .left {
    width: 256px;
    .yiqiImg {
      width: 256px;
      height: 310px;
    }
    .cfdd {
      margin-top: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      .cfddImg {
        width: 19px;
        height: 21px;
        margin-right: 7px;
      }
      .cunfddText {
        width: 150px;
      }
    }
  }
  .right {
    margin-left: 44px;
    .titleBox {
      display: flex;
      align-items: center;
      .chineseTitle {
        max-width: 800px;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .statusBox {
        width: 55px;
        line-height: 24px;
        background: #FCF9F4;
        border-radius: 2px;
        border: 1px solid #F0933D;
        color: #F0933D;
        font-size: 14px;
        font-weight: 400;
        margin-left: 15px;
        text-align: center;
        user-select: none;
      }
    }
    .englishTitle {
      width: 800px;
      font-size: 16px;
      font-weight: 400;
      color: #666666;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .infos {
      margin-top: 16px;
      .infoItem {
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        margin-bottom: 8px;
        .data {
          color: #333333;
        }
        .reserveBtn {
          display: block;
          width: 90px;
          line-height: 30px;
          border-radius: 26px;
          border: 2px solid orange;
          text-align: center;
          color: orange;
          margin-top: 8px;
        }
      }
      .fzrItem {
        display: flex;
        .fzr {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          line-height: 22px;
        }
        .fzrData {
          .data {
            max-width: 600px;
            background: #F7F7F7;
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #666666;
            margin-bottom: 8px;
            padding: 0 8px;
          }
        }
      }
    }
  }
}
.tabs {
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  margin-top: 48px;
  .tabBtn {
    width: 136px;
    height: 100%;
    background: #F2F2F2;
    border-radius: 2px;
    border-top: 1px solid #D9D9D9;
    border-left: 1px solid #D9D9D9;
    border-right: 1px solid #D9D9D9;
    margin-right: 12px;
    line-height: 40px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }
  .active {
    background: #519bcd;
    color: #fff;
  }
}
.tabMain {
  width: 100%;
  padding-top: 24px;
}
.back {
  color: #519bcd;
  cursor: pointer;
  margin-left: 818px;
}
</style>